"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Publish_1 = __importDefault(require("./Publish"));
const Unlock_1 = __importDefault(require("./Unlock"));
const Lock_1 = __importDefault(require("./Lock"));
class Index {
    constructor(parent, noteId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.noteId = noteId;
    }
    path(withParameter = true) {
        if (withParameter && this.noteId !== null) {
            return `${this.parent.path()}/notes/${this.noteId}`;
        }
        return `${this.parent.path()}/notes`;
    }
    /**
     * Returns the specified note(s). It is possible to fetch up to 50 notes per request.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/notes/{noteId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        if (this.noteId === null) {
            throw new Error('noteId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified note.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/notes/{noteId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async delete(restRequestConfig) {
        if (this.noteId === null) {
            throw new Error('noteId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Edits a note. Notes can be edited by any user if posted to a chat. the user belongs to.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/notes/{noteId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async patch(tMCreateNoteRequest, queryParams, restRequestConfig) {
        if (this.noteId === null) {
            throw new Error('noteId must be specified.');
        }
        const r = await this.rc.patch(this.path(), tMCreateNoteRequest, queryParams, restRequestConfig);
        return r.data;
    }
    lock() {
        return new Lock_1.default(this);
    }
    unlock() {
        return new Unlock_1.default(this);
    }
    publish() {
        return new Publish_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map